import script from "./PayCoursePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayCoursePopup.vue?vue&type=script&setup=true&lang=ts"

import "./PayCoursePopup.vue?vue&type=style&index=0&id=bd6b4f8a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd6b4f8a"]])

export default __exports__